import { render, staticRenderFns } from "./ProfilClient.vue?vue&type=template&id=6cb13a41"
import script from "./ProfilClient.vue?vue&type=script&lang=js"
export * from "./ProfilClient.vue?vue&type=script&lang=js"
import style0 from "./ProfilClient.vue?vue&type=style&index=0&id=6cb13a41&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports